import { render } from "./form-buttons.vue?vue&type=template&id=8364ca48"
import script from "./form-buttons.vue?vue&type=script&lang=js"
export * from "./form-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8364ca48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8364ca48', __exports__)) {
    console.log('reload')
    api.reload('8364ca48', __exports__)
  }
  
  module.hot.accept("./form-buttons.vue?vue&type=template&id=8364ca48", () => {
    console.log('re-render')
    api.rerender('8364ca48', render)
  })

}


export default __exports__